"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundcloudAudio1Schema = void 0;
exports.SoundcloudAudio1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/soundcloud-audio/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "SoundcloudAudio1",
    "description": "Embed a soundcloud track or playlist",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:soundcloud-audio:1"
            ]
        },
        "attributes": {
            "type": "object",
            "properties": {
                "id": {
                    "type": "integer",
                    "description": "The ID of a Soundcloud track or playlist"
                },
                "isPlaylist": {
                    "type": "boolean"
                }
            },
            "required": [
                "isPlaylist",
                "id"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9zb3VuZGNsb3VkLWF1ZGlvLzEuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsc0JBQXNCLEdBQUc7SUFDcEMsS0FBSyxFQUFFLHFGQUFxRjtJQUM1RixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxrQkFBa0I7SUFDM0IsYUFBYSxFQUFFLHNDQUFzQztJQUNyRCxNQUFNLEVBQUUsUUFBUTtJQUNoQixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sNkNBQTZDO2FBQzlDO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixZQUFZLEVBQUU7Z0JBQ1osSUFBSSxFQUFFO29CQUNKLE1BQU0sRUFBRSxTQUFTO29CQUNqQixhQUFhLEVBQUUsMENBQTBDO2lCQUMxRDtnQkFDRCxZQUFZLEVBQUU7b0JBQ1osTUFBTSxFQUFFLFNBQVM7aUJBQ2xCO2FBQ0Y7WUFDRCxVQUFVLEVBQUU7Z0JBQ1YsWUFBWTtnQkFDWixJQUFJO2FBQ0w7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsWUFBWTtRQUNaLE1BQU07S0FDUDtDQUNGLENBQUEifQ==